
import page from "~/pages/_.vue";

export default page;
